export default __webpack_public_path__ + "static/media/a2.0f86dae7.jpg";